
import { UniqueCardSection } from "../components/mainPage/uniqueCardSection/UniqueCardSection";
import { SparePartsCardSection } from "../components/mainPage/sparePartsCardSection/SparePartsCardSection";
import { FAQSection } from "../components/mainPage/FAQSection/FAQSection";
import { MainBackgroundSlider } from "../components/mainPage/mainBackgroundSlider/MainBackgroundSlider";
import { ContactsSection } from "../components/mainPage/contactsSection/ContactsSection";
export function MainPage() {
  return (
    <>
      <MainBackgroundSlider />
      <UniqueCardSection />
      <SparePartsCardSection />
      {/* <FAQSection /> */}
      <ContactsSection />
    </>
  );
}
